const Codes = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="54"
      viewBox="0 0 76 54"
      fill="none"
    >
      <path
        d="M29.917 2V0.25C29.0623 0.25 28.3326 0.867474 28.1912 1.71045L29.917 2ZM18.083 2L19.8088 1.71045C19.6674 0.867474 18.9377 0.25 18.083 0.25V2ZM19.083 52V53.75C19.9377 53.75 20.6674 53.1325 20.8088 52.2895L19.083 52ZM30.917 52L29.1912 52.2895C29.3326 53.1325 30.0623 53.75 30.917 53.75V52ZM24 8.75C27.8419 8.75 31.0278 5.95626 31.6429 2.28955L28.1912 1.71045C27.8542 3.71917 26.1041 5.25 24 5.25V8.75ZM16.3571 2.28955C16.9722 5.95626 20.1581 8.75 24 8.75V5.25C21.8959 5.25 20.1458 3.71917 19.8088 1.71045L16.3571 2.28955ZM6 3.75H18.083V0.25H6V3.75ZM3.75 6C3.75 4.75736 4.75736 3.75 6 3.75V0.25C2.82436 0.25 0.25 2.82436 0.25 6H3.75ZM3.75 48V6H0.25V48H3.75ZM6 50.25C4.75736 50.25 3.75 49.2426 3.75 48H0.25C0.25 51.1756 2.82437 53.75 6 53.75V50.25ZM19.083 50.25H6V53.75H19.083V50.25ZM25 45.25C21.1581 45.25 17.9722 48.0437 17.3571 51.7105L20.8088 52.2895C21.1458 50.2808 22.8959 48.75 25 48.75V45.25ZM32.6429 51.7105C32.0278 48.0437 28.8419 45.25 25 45.25V48.75C27.1041 48.75 28.8542 50.2808 29.1912 52.2895L32.6429 51.7105ZM70 50.25H30.917V53.75H70V50.25ZM72.25 48C72.25 49.2426 71.2426 50.25 70 50.25V53.75C73.1756 53.75 75.75 51.1756 75.75 48H72.25ZM72.25 6V48H75.75V6H72.25ZM70 3.75C71.2426 3.75 72.25 4.75736 72.25 6H75.75C75.75 2.82436 73.1756 0.25 70 0.25V3.75ZM29.917 3.75H70V0.25H29.917V3.75Z"
        fill="#333333"
      />
      <path
        d="M24.5 13L24.5 41"
        stroke="#FC8037"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeDasharray="6 6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61 23.5C61.9665 23.5 62.75 22.7165 62.75 21.75C62.75 20.7835 61.9665 20 61 20H38C37.0335 20 36.25 20.7835 36.25 21.75C36.25 22.7165 37.0335 23.5 38 23.5H61ZM61 33.5C61.9665 33.5 62.75 32.7165 62.75 31.75C62.75 30.7835 61.9665 30 61 30H38C37.0335 30 36.25 30.7835 36.25 31.75C36.25 32.7165 37.0335 33.5 38 33.5H61Z"
        fill="#FC8037"
      />
    </svg>
  )
}

export default Codes
